import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that returns the initials of a string.
 */
@Pipe({
  name: 'initials',
})
export class InitialsPipe implements PipeTransform {
  transform(value: string): string {
    return value
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  }
}
